// @flow
import React, { Component } from 'react';
import moment from 'moment';

import ValidateText from './ValidateText.jsx';

/*
  Text that validates Datetime in format of "DD-MM-YYYY, HH:MM" (military time)
  Same restrictions on date as DateText
*/

type Props = {
  field: string,
  initialValue?: ?string,
  initEmpty?: boolean,
}

class DatetimeText extends Component<Props> {
  render() {
    const {
      field, initialValue, initEmpty, ...rest
    } = this.props;
    let initialDateValue;
    if (initEmpty) {
      initialDateValue = initialValue ? moment(initialValue).format('DD-MM-YYYY, HH:mm') : null;
    } else {
      initialDateValue = initialValue ? moment(initialValue).format('DD-MM-YYYY, HH:mm') : moment().format('DD-MM-YYYY, HH:mm');
    }

    return <ValidateText
      field={this.props.field}
      initialValue={initialDateValue}
      regex={/^((0?[1-9]|[12][0-9]|3[01])-(0?[1-9]|1[012])-(19|20|21)\d\d, (([0-1]\d)|(2[0-3])):[0-5]\d)?$/}
      errorText={'Invalid format, please use DD-MM-YYYY, HH:MM'}
      placeholder={'DD-MM-YYYY HH:MM'}
      {...rest}
    />;
  }
}

export default DatetimeText;



// WEBPACK FOOTER //
// ./client/src/components/DatetimeText.jsx